import { forwardRef } from "react";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { Form } from "@shared/components";
import { getPlansService } from "@modules/plans/services/queries/listPlans/service";

interface PlansAutocompleteProps extends Omit<FormAutocompleteProps, "options"> {
  /** ID do convênio para filtrar planos */
  agreement?: number | string | null;
}

export const PlansAutocomplete = forwardRef<
  HTMLInputElement,
  PlansAutocompleteProps
>(({ agreement, ...props }, ref) => {
  return (
    <Form.Autocomplete
      labelField="display_name"
      {...props}
      ref={ref}
      queryHook={getPlansService}
      queryHookFilters={agreement ? { agreement: String(agreement) } : undefined}
    />
  );
});

PlansAutocomplete.displayName = "PlansAutocomplete";
